import myDialog from './myDialog.vue'
const my_dialog = {
    install: function(Vue) {
        Vue.component('my_dialog', myDialog)
    }
};
// 导出组件
export default my_dialog